import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'shared-components/Button';
import generateErrorPageStyles from 'styles/ErrorPageStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

export const UnknownError = () => {
    const theme = useTheme();
    const styles = useMemo(() => generateErrorPageStyles(theme), [theme]);

    return (
        <Box sx={styles.wrapper}>
            <img src="/assets/images/unknown-error.svg" alt="Not Found" />
            <Box sx={styles.title}>Whoops!</Box>
            <Box sx={styles.description}>
                Something went wrong.
                <br />
                Go back to the home screen or create a support ticket.
            </Box>
            <Link to="/"><Button>Return to home screen</Button></Link>
        </Box>
    );
};
